module.exports = __webpack_public_path__ + "static/img/model-collect6.1148fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-collect6.png
// module id = wbNL
// module chunks = 36